import { shouldApplyEAEULogic } from '../../../../utils/eaeuHelper';

const NUMERIC_TO_ALPHA_COUNTRY_CODE = {
    1:  'RU',
    48: 'KZ',
};

export default function arrangeInvoiceParams(invoiceData) {
    let data = {};

    data.is_voice = invoiceData.is_voice;
    data.template_name = invoiceData.template_name;
    data.tariff_name = invoiceData.tariff_name;
    data.period_min = invoiceData.period_min;
    data.period_max = invoiceData.period_max;
    data.need_barcode = invoiceData.need_barcode;
    
    // Check if this is an EAEU shipment
    data.modified_from_default = shouldApplyEAEULogic(invoiceData.cityFromCountryCode, invoiceData.cityToCountryCode);
    
    // sender
    data.sender = {
        FIO: invoiceData.delivery?.sender?.fio,
        contact_face: invoiceData.delivery?.sender?.contract_face,
        phones: invoiceData.delivery?.sender?.phones
    }

    //reciver
    data.reciver = {
        FIO: invoiceData.delivery?.recipient?.fio,
        contact_face: invoiceData.delivery?.recipient?.contract_face,
        phones: invoiceData.delivery?.recipient?.phones
    }

    // contract number
    data.contract_number = invoiceData.contract_number;
    data.who_pay = invoiceData.user_type;

    // city_from
    data.city_from = invoiceData.cityFrom;
    data.source_country_code = NUMERIC_TO_ALPHA_COUNTRY_CODE[invoiceData.cityFromCountryCode] ?? 'RU';

    // city_to
    data.city_to = invoiceData.cityTo;
    data.destination_country_code = NUMERIC_TO_ALPHA_COUNTRY_CODE[invoiceData.cityToCountryCode] ?? 'RU';

    // pay_on_recieve
    data.pay_on_recieve = invoiceData.payment_on_receipt;

    // vat_rate
    data.vat_rate = invoiceData.vat;

    // who
    data.who = invoiceData.user_type

    // places
    let p = [];

    // Get currency conversion info
    const cityTo = invoiceData.cityToCountryCode;
    const isKZContract = invoiceData?.user_info?.is_kz;
    const currencyRate = invoiceData.currencyRate || 6.0; // Fallback to default rate
    const shouldConvertPrices = invoiceData.payment_on_receipt;

    invoiceData.places.map((place, i) => {
        let g = [];
        
        place.goods.map((good) => {
            let article = good.article;

            if (invoiceData.cityToCountryCode != 1 || invoiceData.cityFromCountryCode != 1) {
                article = null;
            }

            // Convert good.price (доп. сбор с получателя) for API if needed
            let priceForAPI = good.price;

            g.push({
                name: good.name,
                price: good.insurance,
                quantity: good.count,
                weight: good.weight,
                article: article,
                price_alter_vat: priceForAPI,
                vat_rate: good.vat,
                vat_sum: good.vat_sum
            })
        })

        p.push({
            number: i + 1,
            weight: place.weight,
            length: place.length,
            width: place.width,
            height: place.height,
            goods: g
        })
    });

    data.places = p;

    // city labels
    data.city_label_from = invoiceData.cityFromLabel;
    data.city_label_to = invoiceData.cityToLabel;
    data.city_from_label = invoiceData.cityFromLabel;
    data.city_to_label = invoiceData.cityToLabel;

    // tariff
    data.tariff_code = invoiceData.tariff;
    data.selected_mode = invoiceData.selected_mode;
    data.delivery_sum = invoiceData.delivery_sum;

    // services
    if (invoiceData.additions?.HEAVY_GOOD) {
        // go for places to check if we actually need heavy good
        /*let heavyGood = false;
        let heaveHeavyGood = false;
        let total_weight = 0;

        data.places.map((place) => {
            if (place.weight >= 75 && place.weight <= 200) {
                heavyGood = true;
            }
            if (place.weight > 200) {
                heaveHeavyGood = true;
            }

            total_weight += place.weight;
        });

        if (!heavyGood && !heaveHeavyGood) {
            data.servoce
        }*/
    }
    data.services = {...invoiceData.additions};
    data.service_prices = {...invoiceData.additions_separated_prices};
    data.service_price = invoiceData.additions_sum;

    // Filter out GET_UP_FLOOR_BY_HAND - it's just an internal flag, not a service
    if (data.services.GET_UP_FLOOR_BY_HAND !== undefined) {
        delete data.services.GET_UP_FLOOR_BY_HAND;
        delete data.service_prices.GET_UP_FLOOR_BY_HAND;
    }

    // Handle GET_UP service - replace with GET_UP_FLOOR_BY_HAND or GET_UP_FLOOR_BY_ELEVATOR based on elevator selection
    if (data.services.GET_UP) {
        const getUpValue = data.services.GET_UP; // This is the floor number
        const getUpPrice = data.service_prices.GET_UP;
        
        // Check if elevator is selected (GET_UP_FLOOR_BY_HAND = true means has elevator)
        // Use additions_extra_info if available, otherwise check GET_UP_FLOOR_BY_HAND directly
        const hasElevator = invoiceData.additions_extra_info?.GET_UP === "by_elevator" || 
                           invoiceData.additions?.GET_UP_FLOOR_BY_HAND === true;
        
        if (hasElevator) {
            // Replace GET_UP with GET_UP_FLOOR_BY_ELEVATOR (has elevator)
            data.services.GET_UP_FLOOR_BY_ELEVATOR = getUpValue;
            if (getUpPrice !== undefined) {
                data.service_prices.GET_UP_FLOOR_BY_ELEVATOR = getUpPrice;
            }
            delete data.services.GET_UP;
            delete data.service_prices.GET_UP;
        } else {
            // Replace GET_UP with GET_UP_FLOOR_BY_HAND (no elevator / by hand)
            data.services.GET_UP_FLOOR_BY_HAND = getUpValue;
            if (getUpPrice !== undefined) {
                data.service_prices.GET_UP_FLOOR_BY_HAND = getUpPrice;
            }
            delete data.services.GET_UP;
            delete data.service_prices.GET_UP;
        }
    }

    if (invoiceData.additions?.HEAVY_GOOD) {
        delete data.services.HEAVY_GOOD;
    }

    // If service value is 0 delete service
    for (let key in data.services) {
        if (data.services[key] === 0) {
            delete data.services[key];
            delete data.service_prices[key];
        }
    }

    // delivery
    data.courier_date = invoiceData.delivery_date_from;
    data.courier_time_from = invoiceData.delivery_date_from;
    data.courier_time_to = invoiceData.delivery_date_to;
    data.courier_break_from = invoiceData.break_time_from;
    data.courier_break_to = invoiceData.break_time_to;

    // address
    data.from_address = invoiceData.addressFrom;
    data.to_address = invoiceData.addressTo;

    data.to_pvz_address = invoiceData.pvzTo;
    data.to_pvz_address_label = invoiceData.pvzToLabel;

    // pay
    // Use converted value for API (destination currency) if available, otherwise use display value (contract currency)
    data.delivery_pay = invoiceData.delivery_pay_amount_for_api || invoiceData.delivery_pay_amount;
    data.contract_pay = invoiceData.contract_pay;
    data.additional_sum = invoiceData.hand_sum || invoiceData.additional_sum;
    // Additional fee for KZ contracts (already included in delivery_pay_amount, but store separately if needed)
    if (invoiceData.additional_fee) {
        data.additional_fee = invoiceData.additional_fee;
    }

    return data;
}
